import { aboutInfo } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-600 bg-secondary-100 rounded-full mb-4">
            了解我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            {aboutInfo.title}
          </h2>
        </div>

        <p className="text-sm md:text-base text-foreground-600 leading-relaxed text-center max-w-3xl mx-auto mb-10">
          {aboutInfo.content}
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {aboutInfo.highlights.map((item) => (
            <div
              key={item.label}
              className="text-center p-5 bg-background-100 rounded-xl border border-background-200/70"
            >
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">
                {item.value}
              </div>
              <div className="text-xs text-foreground-500">{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}